import type { LovCarDTO } from '@/features/api/extranet/dto/Demande/CAR'
import {
  getNaturesFichiersCar as getNaturesFichiers,
  propertyStatusConfiguration,
  reglesConfiguration,
} from '@/features/domaine/regles-akto/CAR'
import CarServices from '@/features/services/demande/car/CarServices'
import { buildDemandeStore } from '../shared'

export const useDemandeCARStore = buildDemandeStore<'MODEL_CAR', LovCarDTO>({
  model: 'MODEL_CAR',
  typeDemande: 'Formation',
  module: 'demande',
  demandeService: CarServices,
  propertyStatusConfiguration,
  reglesConfiguration,
  getNaturesFichiers,
})
